import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "../../../../../../constants/colors";
import { IconOffer, ProMembershipIcon } from "../../../../../../assets/svg";
import {
  RocketOutlined,
  CheckOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { Button, Flex, Typography } from "antd";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../../constants/config/appConfig";
import { getUserProfileAction } from "../../../../../../redux/services/auth/authServices";
import Spinner from "../../../../../common/spinner/Spinner";
import { useTranslation } from "react-i18next";

const ActivePlan = () => {
  const { loginDetails } = useSelector((state) => state.auth);

  const {t} = useTranslation();

  const dispatch = useDispatch();

  /* local storage dependencies */
  const { userSession, setUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );
  /* local storage dependencies */

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    userSession &&
      Object.keys(userSession).length !== 0 &&
      userSession !== null &&
      userSession !== undefined &&
      dispatch(getUserProfileAction(setUserSession));

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const subscriptionCodes = {
    FREE: {
      icon: <IconOffer fillColor={colors.deepSafron} />,
      color: colors.deepSafron,
      lightColor: colors.lightBeige,
    },
    PREMIUM: {
      icon: (
        <RocketOutlined style={{ color: colors.royalPurple, fontSize: 20 }} />
      ),
      color: colors.royalPurple,
      lightColor: colors.lavenderBlue,
    },
    "ELITE-PREMIUM": {
      icon: <ProMembershipIcon fillColor={colors.turquoise} />,
      color: colors.turquoise,
      lightColor: colors.lightCyan,
    },
  };


  return (
    <Flex gap="2rem" justify="center">
      {
        loading ?
        <Spinner/>
        :
        <div
        className="cardContainer"
        style={{
          width: 400,
          height: 500,
          boxShadow: "1px 4px 8px rgba(0,0,0,0.1)",
          background: "#F5F5F5",
          border: `1px solid ${
            subscriptionCodes[
              loginDetails?.organization_id?.current_plan_id?.code
            ]?.color
          }`,
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          padding: 20,
          borderRadius: 20,
        }}
      >
        <Flex gap="1rem" vertical>
          <Flex gap="1rem" align="center">
            <div
              style={{
                borderRadius: "50%",
                border: `4px solid ${
                  subscriptionCodes[
                    loginDetails?.organization_id?.current_plan_id?.code
                  ]?.color
                }`,
                width: 40,
                height: 40,
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {
                subscriptionCodes[
                  loginDetails?.organization_id?.current_plan_id?.code
                ]?.icon
              }
            </div>
            <Typography.Title level={2}>
              {loginDetails?.organization_id?.current_plan_id?.name}
            </Typography.Title>
          </Flex>

          <div>
            {loginDetails?.organization_id?.current_plan_id?.features &&
              loginDetails?.organization_id?.current_plan_id?.features?.map(
                (feature, index) => (
                  <Flex gap="1rem">
                    <CheckOutlined
                      style={{
                        color:
                          subscriptionCodes[
                            loginDetails?.organization_id?.current_plan_id?.code
                          ]?.color,
                        background:
                          subscriptionCodes[
                            loginDetails?.organization_id?.current_plan_id?.code
                          ]?.lightColor,
                        borderRadius: "50%",
                        width: 25,
                        height: 25,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                    <Typography.Paragraph key={index}>
                      {feature}
                    </Typography.Paragraph>
                  </Flex>
                )
              )}
          </div>
          <Flex vertical align="center" justify="center" gap="1rem">
            <Typography.Title
              level={3}
              style={{ color: colors.gunMetalGray, margin: 0 }}
            >
              {t("CommonUtils.noOfUsers")} :{" "}
              {loginDetails?.organization_id?.free_users_allowed}
            </Typography.Title>
            {loginDetails?.organization_id?.current_plan_id?.code !==
              "FREE" && (
              <>
                <Typography.Title
                  level={3}
                  style={{ color: colors.gunMetalGray, margin: 0 }}
                >
                  {t("CommonUtils.planExpiryDate")} :{" "}
                  {dateObjToDispViewDate(
                    loginDetails?.organization_id
                      ?.current_plan_payment_transaction_id?.expire_date_time,
                    "ddmmyyyy"
                  )}
                </Typography.Title>
                {/* <Typography.Title
                  level={3}
                  style={{ color: colors.gunMetalGray, margin: 0 }}
                >
                  {t("CommonUtils.totalNoOfUsers")} :{" "}
                  {
                    loginDetails?.organization_id
                      ?.current_plan_payment_transaction_id
                      ?.number_of_total_logins
                  }
                </Typography.Title> */}
                <Typography.Title
                  level={2}
                  style={{
                    color:
                      subscriptionCodes[
                        loginDetails?.organization_id?.current_plan_id?.code
                      ]?.color,
                    margin: 0,
                  }}
                >
                  {`${loginDetails?.organization_id?.current_plan_payment_transaction_id?.total_amount?.toFixed(2)} ${loginDetails?.organization_id?.current_plan_payment_transaction_id?.currency} ${loginDetails?.organization_id?.current_plan_payment_transaction_id?.duration} ${loginDetails?.organization_id?.current_plan_payment_transaction_id?.duration_unit}`}
                </Typography.Title>
                <Button
                  onClick={() => {
                    const link = document.createElement("a");
                    link.href =
                      loginDetails?.organization_id?.current_plan_payment_transaction_id?.invoice_url;
                    link.download = "Invoice.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  {t("CommonUtils.downloadInvoice")} <FilePdfOutlined style={{ fontSize: 20 }} />
                </Button>
              </>
            )}
          </Flex>
        </Flex>
      </div>
      }
      
    </Flex>
  );
};

export default ActivePlan;
